"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Provider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _url = require("./lib/url");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var LinkContext = (0, _react.createContext)();

var Provider = function Provider(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      _ref$isStatic = _ref.isStatic,
      isStatic = _ref$isStatic === void 0 ? function (href) {
    return false;
  } : _ref$isStatic,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? '' : _ref$lang;
  return _react["default"].createElement(LinkContext.Provider, {
    value: {
      lang: lang,
      isStatic: isStatic,
      component: component
    }
  }, children);
};

exports.Provider = Provider;
Provider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  lang: _propTypes["default"].string,
  isStatic: _propTypes["default"].func,
  component: _propTypes["default"].any
};
var LinkInner = (0, _react.forwardRef)(function (props, ref) {
  // Transform original href to prefix language where applicable
  function getHref() {
    if (props.lang && (0, _url.isRelative)(props.href) && !props.isStatic(props.href) && !props.href.match(new RegExp("^/".concat(props.lang, "(/?|/.*)$"))) && !props.href.match(/^(#|\?)/)) {
      return "/".concat(props.lang).concat(props.href);
    }

    return props.href;
  }

  var Component = props.component;

  var componentProps = _objectSpread({}, props, {
    href: getHref(),
    isStatic: props.isStatic(props.href),
    isRelative: (0, _url.isRelative)(props.href)
  });

  delete componentProps.component;

  if (typeof Component === 'string') {
    delete componentProps.isStatic;
    delete componentProps.isRelative;
  }

  return _react["default"].createElement(Component, (0, _extends2["default"])({}, componentProps, {
    ref: ref
  }));
});
var Link = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(LinkContext.Consumer, null, function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        lang = _ref2.lang,
        _ref2$isStatic = _ref2.isStatic,
        isStatic = _ref2$isStatic === void 0 ? function () {
      return false;
    } : _ref2$isStatic,
        _ref2$component = _ref2.component,
        component = _ref2$component === void 0 ? 'a' : _ref2$component;

    return _react["default"].createElement(LinkInner, (0, _extends2["default"])({}, props, {
      ref: ref,
      lang: lang,
      isStatic: isStatic,
      component: component
    }));
  });
});
LinkInner.propTypes = {
  href: _propTypes["default"].string.isRequired,
  lang: _propTypes["default"].string,
  isStatic: _propTypes["default"].func,
  elRef: _propTypes["default"].any,
  component: _propTypes["default"].any
};
Link.propTypes = {
  href: _propTypes["default"].string.isRequired
};
var _default = Link;
exports["default"] = _default;